require './follow_merchant_modal'

MIN_MODAL_WIDTH = 767

class Groupon.FollowMerchantMainContent

  constructor: (@el, @csrf, @showNearbyPlaces) ->
    @$container = $(@el)
    @$mainContentContainer = @$container.find '.follow-merchant-main-full'
    @$followMainContent = @$container.find '.follow-merchant-info'
    @$cta = @$container.find '.post-follow-cta'
    @$loading = @$container.find '.loading'
    @$followButton = @$container.find '#follow-merchant-main-content-btn'

    @initBindings()

    $('.mpp-container').removeClass 'no-merchant-offer'

  initBindings: ->
    $('#follow-merchant-main-content-btn').click =>
      @showLoading()
      @mainWidgetFollow = true
      @$container.trigger 'follow-requested'

    $('.follow-merchant-righthand-module').on 'follow-successful', (event, data) =>
      @hideLoading()
      if @mainWidgetFollow
        @mainWidgetFollow = false
        @showModal(data) if @showNearbyPlaces and $(window).width() > MIN_MODAL_WIDTH
      @showCTA()

    $('.follow-merchant-righthand-module').on 'follow-unsuccessful', (event) =>
      @removeWidget()

    $('.follow-merchant-righthand-module').on 'unfollow-successful', (event) =>
      @removeWidget()

  showLoading: ->
    @$followButton.addClass 'hide'
    @$loading.show()

  hideLoading: ->
    @$loading.hide()
    @$followButton.removeClass 'hide'

  showCTA: ->
    @$followMainContent.fadeOut 200, =>
      @$followMainContent.hide()
      @$cta.fadeIn(200)

  showModal: (data) ->
    @followModal = new Groupon.FollowMerchantModal('#follow-merchant-nearby-places-modal', data, @csrf)
    @followModal.openModal()

  removeWidget: ->
    @$mainContentContainer.slideUp 200, => @$container.remove()
    $('.mpp-container').addClass 'no-merchant-offer'
